import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { BUSINESS_TYPE_CONFIGS, BusinessTypeConfig } from '../theme/constants';

// Add timezone information map for each business type
export const TZ_INFO_MAP: Record<string, { timeZone: string }> = {
  standard: { timeZone: 'America/Mexico_City' },
  premium: { timeZone: 'America/Mexico_City' },
  professional: { timeZone: 'America/Mexico_City' },
  enterprise: { timeZone: 'America/Mexico_City' }
};

interface BusinessTypeContextProps {
  businessType: string;
  config: BusinessTypeConfig;
  changeBusinessType: (type: string) => Promise<void>;
}

const BusinessTypeContext = createContext<BusinessTypeContextProps | undefined>(undefined);

export const useBusinessType = () => {
  const context = useContext(BusinessTypeContext);
  if (context === undefined) {
    throw new Error('useBusinessType must be used within a BusinessTypeProvider');
  }
  return context;
};

interface BusinessTypeProviderProps {
  children: ReactNode;
}

export const BusinessTypeProvider: React.FC<BusinessTypeProviderProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const [businessType, setBusinessType] = useState<string>('standard');
  const [config, setConfig] = useState<BusinessTypeConfig>(BUSINESS_TYPE_CONFIGS.standard);

  useEffect(() => {
    if (currentUser?.businessType) {
      setBusinessType(currentUser.businessType);
      setConfig(BUSINESS_TYPE_CONFIGS[currentUser.businessType] || BUSINESS_TYPE_CONFIGS.standard);
    }
  }, [currentUser]);

  const changeBusinessType = async (type: string): Promise<void> => {
    // Esta función sería usada por un administrador para cambiar 
    // el tipo de un negocio, pero por ahora solo actualizamos el estado local
    setBusinessType(type);
    setConfig(BUSINESS_TYPE_CONFIGS[type] || BUSINESS_TYPE_CONFIGS.standard);
  };

  return (
    <BusinessTypeContext.Provider value={{ businessType, config, changeBusinessType }}>
      {children}
    </BusinessTypeContext.Provider>
  );
};